import { render, staticRenderFns } from "./MaterialTabsCard.vue?vue&type=template&id=b2d407ba"
import script from "./MaterialTabsCard.vue?vue&type=script&lang=js"
export * from "./MaterialTabsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports